import { https } from "./api";

export default class {
  constructor() {
    this.instance = https("/mailing");
  }

  getTypes = () => {
    return this.instance({
      method: "GET",
      url: `/types`
    });
  };

  getMy = () => {
    return this.instance({
      method: "GET",
      url: `/my`
    });
  };

  getMyMailings = (params = {}) => {
    return this.instance({
      method: "GET",
      url: "/my-mailings",
      params
    });
  };

  getApprentices = () => {
    return this.instance({
      method: "GET",
      url: "/apprentices"
    });
  };

  createApprenticeActivity = async data => {
    return await this.instance({
      method: "POST",
      url: "/apprentice-activity",
      data
    });
  };

  getCampaignUtms = code => {
    return this.instance({
      method: "GET",
      url: `/campaign-utms/${code}`
    });
  };

  getMyAttendance = (params = {}) => {
    return this.instance({
      method: "GET",
      url: "/my-attendance",
      params
    })
  };

  getForm = code => {
    return this.instance({
      method: "GET",
      url: `/types/${code}/form`
    });
  };

  validateProspect = data => {
    return this.instance({
      method: "POST",
      url: "/validateProspect",
      data
    });
  };

  searchAttendance = codAttendance => {
    return this.instance({
      method: "GET",
      url: `/searchAttendance/${codAttendance}`
    });
  };

  getCities = stateID => {
    return this.instance({
      method: "GET",
      url: `/cities/${stateID}`
    });
  };

  getStates = () => {
    return this.instance({
      method: "GET",
      url: "/states"
    });
  };

  reasonNotContact = () => {
    return this.instance({
      method: "GET",
      url: "/not-contact"
    });
  };

  reasonNotEnrolling = () => {
    return this.instance({
      method: "GET",
      url: "/not-enrolling"
    });
  };

  courseAttendance = () => {
    return this.instance({
      method: "GET",
      url: "/course"
    });
  };

  getDiscussion = (colligateId, localId, atttendanceId) => {
    return this.instance({
      method: "GET",
      url: `/${colligateId}/${localId}/${atttendanceId}/discussion`
    });
  };

  createLeadSimulated = async data => {
    return await this.instance({
      method: "POST",
      url: "/simulated",
      data
    });
  };

  registerMailing = async data => {
    return await this.instance({
      method: "PUT",
      url: "/",
      data
    });
  };

  updateParamsAttendance = async data => {
    return await this.instance({
      method: "PUT",
      url: "/params",
      data
    });
  };

  updateAttachmentAttendance = async data => {
    return await this.instance({
      method: "PUT",
      url: "/attachment",
      data
    });
  };

  updateParamsDiscussion = async data => {
    return await this.instance({
      method: "PUT",
      url: "/params-discussion",
      data
    });
  };

  updateProspectAttendance = async data => {
    return await this.instance({
      method: "PUT",
      url: "/update-prospect",
      data
    });
  };

  updateDiscussion = (text, atttendanceId, localId, associatedId) => {
    return this.instance({
      method: "PUT",
      url: "/discussion",
      data: {
        text,
        atttendanceId,
        localId,
        associatedId
      }
    });
  };

  createReAttendance = (
    coligateId,
    ra,
    qualificationId,
    codAttendendanceResp,
    name,
    codLocal
  ) => {
    return this.instance({
      method: "POST",
      url: "/crmattendance",
      timeout: 240000,
      data: {
        coligateId,
        ra,
        qualificationId,
        codAttendendanceResp,
        name,
        codLocal
      }
    });
  };
}
